unit Principal;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls, Vcl.Mask, WEBLib.JSON,
  WEBLib.Mask, Vcl.Controls, WEBLib.Buttons, WEBLib.ExtCtrls, Vcl.Imaging.jpeg,
  Vcl.Imaging.pngimage, WEBLib.REST, WEBLib.CDS;

type
  TFormPrincipal = class(TForm)
    WebPanel1: TPanel;
    PainelContribuicao: TPanel;
    WebLabel1: TLabel;
    BotaoOK: TBitBtn;
    WebLabel2: TLabel;
    WebLabel3: TLabel;
    WebComboBoxCategorias: TComboBox;
    EditData: TDateTimePicker;
    WebButton1: TButton;
    WebHttpRequest1: THttpRequest;
    WebRESTClient1: TRESTClient;
    LabelEmpresa: TLabel;
    EditCNPJ: TMaskEdit;
    WebPanel2: TPanel;
    ConnectionBanco: TClientConnection;
    procedure BotaoOKClick(Sender: TObject);
    procedure OnHttpResponse(Sender: TObject; AResponse: string);
    procedure WebFormCreate(Sender: TObject);
    procedure WebButton1Click(Sender: TObject);
    procedure EditCNPJKeyPress(Sender: TObject; var Key: Char);
    procedure EditCNPJEnter(Sender: TObject);
    procedure ConnectionBancoDataReceived(Sender: TObject;
      ARequest: TJSXMLHttpRequestRecord; var AResponse: string);
//    procedure OnHttpResponse(Sender: TObject; AResponse: string);
  private
    { Private declarations }
    Matricula:Integer;
    ChamadaAPI:string;
    Retorno:Boolean;
    DataCobranca, Tipo:string;
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  FormPrincipal: TFormPrincipal;

implementation

{$R *.dfm}

procedure TFormPrincipal.BotaoOKClick(Sender: TObject);
var
   Temp:string;
begin
     try

        ChamadaAPI:='empresa';
     ConnectionBanco.Active:=false;
//     ConnectionBanco.Headers.AddPair('Cache-Control', 'no-cache');
     Temp:='?cnpj='+EditCNPJ.text;
     Temp:=Temp+'&nocache=' +  FormatDateTime('yyyymmddhhnnsszzz', Now);
     ConnectionBanco.URI:='https://sindicatoamericana.com.br/appboletos/buscacnpj.php'+Temp;
     ConnectionBanco.Active:=true;

{
        WebHttpRequest1.URL:='https://sindicatoamericana.com.br/appboletos/buscacnpj.php?cnpj='+EditCNPJ.Text;
        ChamadaAPI:='empresa';
        WebHttpRequest1.Command := httpGET;
      WebHttpRequest1.OnResponse := OnHttpResponse;
        WebHttpRequest1.Execute;
}
    except
//    showmessage('erro');
    end;
end;

procedure TFormPrincipal.WebButton1Click(Sender: TObject);
var
   Temp, URL, DataCobranca1, NomeArq:string;
   Ano, Mes, Dia:Word;
begin
     if WebComboBoxCategorias.Text = 'Convênio Odontológico' then
        Tipo:='0'
     else if WebComboBoxCategorias.Text = 'Contribuição Assistencial' then
          Tipo:='1'
     else if WebComboBoxCategorias.Text = 'Mensalidade Sindical' then
          Tipo:='9'
     else
         Tipo:='8';
     DecodeDate(EditData.Date, Ano, Mes, Dia);
     DataCobranca:=FormatFloat('0000', Ano)+'_'+FormatFloat('00', Mes)+'_'+FormatFloat('00', Dia);
     DataCobranca1:=FormatFloat('0000', Ano)+'-'+FormatFloat('00', Mes)+'-'+FormatFloat('00', Dia);
//     try
        ConnectionBanco.Active:=false;
        ChamadaAPI:='boleto';
        Temp:='?codigo='+inttostr(Matricula);
        Temp:=Temp+'&datacobranca='+DataCobranca1;
        Temp:=Temp+'&tipocontribuicao='+tipo;


        ConnectionBanco.URI:='https://sindicatoamericana.com.br/appboletos/buscaboleto.php'+Temp;
showmessage(ConnectionBanco.URI);

        ConnectionBanco.Active:=true;
{
        WebHttpRequest1.URL:='https://sindicatoamericana.com.br/appboletos/buscaboleto.php?codigo='+inttostr(Matricula)+'&datacobranca='+DataCobranca1+'&tipocontribuicao='+tipo;
        ChamadaAPI:='boleto';
        Retorno:=true;
        WebHttpRequest1.Command := httpGET;
        WebHttpRequest1.OnResponse := OnHttpResponse;
        WebHttpRequest1.Execute;
}
{
        if not Retorno  then begin
           Showmessage('Boleto bancário não localizado!');
           exit;
        end;
}
//    except
//    showmessage('erro');
//    end;


//     URL:='https://sindicatoamericana.com.br/boletos/';
//     NomeArq:=URL+ FormatFloat('00000', Matricula)+'_'+Tipo+'_'+DataCobranca+'.pdf';
// asm
 //   fetch(NomeArq, { method: 'HEAD' })
//      .then(function(response) {
//        if (response.ok) {
//          window.open(NomeArq, '_blank');
//        } else {
//          alert('Boleto bancário não encontrado.');
//        }
//      })
//      .catch(function(error) {
//        alert('Erro ao verificar: ' + error);
//      });
//  end;

{
     WebHttpRequest1.URL := 'https://sindicatoamericana.com.br/boletos/'+NomeArq;
     WebHttpRequest1.Command:=httpGET;
     WebHttpRequest1.OnError := OnError;

     WebHttpRequest1.Execute;
}

// window.open('https://seusite.com/boleto.pdf', '_blank');
end;

procedure TFormPrincipal.WebFormCreate(Sender: TObject);
begin
     LabelEmpresa.Caption:='';
end;

procedure TFormPrincipal.ConnectionBancoDataReceived(Sender: TObject;
  ARequest: TJSXMLHttpRequestRecord; var AResponse: string);
var
   i:integer;
   URL, NomeArq, Temp:string;

// js: TJSON;
// ja: TJSONArray;
 jo: TJSONObject;
 jsonObj: TJSObject;
  dados: TJSArray;
 item: TJSObject;
begin
//     JS := TJSON.Create;
//     JA := TJSONArray(JS.Parse(AResponse));

  jsonObj := TJSObject(TJSJSON.Parse(AResponse));
  dados := TJSArray(jsonObj['dados']);
//showmessage(aresponse);
    if ChamadaAPI = 'empresa' then begin
        if dados.toString = '' then begin

//       if JA.Count = 0 then begin
          showmessage('CNPJ não encontrado!');
          LabelEmpresa.Caption:='';
          PainelContribuicao.Visible:=false;
          exit;
       end;
       item := TJSObject(dados[0]);
       Matricula:=StrToIntDef(String(item['MATRICULA']), 0);
       LabelEmpresa.caption:=String(item['RAZAOSOCIAL']);
       WebComboBoxCategorias.Items.Clear;

       if String(item['ODONTO']) = 'T' then
          WebComboBoxCategorias.Items.Add('Convênio Odontológico');
       if String(item['ASSISTENCIAL']) = 'T' then
          WebComboBoxCategorias.Items.Add('Contribuição Assistencial');
       if String(item['MENSALIDADE']) = 'T' then
          WebComboBoxCategorias.Items.Add('Mensalidade Sindical');
       WebComboBoxCategorias.Items.Add('Negocial');
       PainelContribuicao.Visible:=true;

{
       WebComboBoxCategorias.Items.Clear;
       for i := 0 to JA.Count - 1 do begin
           JO := TJSONObject(JA.Items[i]);
           Matricula:=StrToIntDef(JO.GetJSONValue('MATRICULA'), 0);
           LabelEmpresa.caption:=JO.GetJSONValue('RAZAOSOCIAL');
           if JO.GetJSONValue('ODONTO') = 'T' then
              WebComboBoxCategorias.Items.Add('Convênio Odontológico');
           if JO.GetJSONValue('ASSISTENCIAL') = 'T' then
              WebComboBoxCategorias.Items.Add('Contribuição Assistencial');
           if JO.GetJSONValue('MENSALIDADE') = 'T' then
              WebComboBoxCategorias.Items.Add('Mensalidade Sindical');
           WebComboBoxCategorias.Items.Add('Negocial');
           PainelContribuicao.Visible:=true;
       end;
}
       exit;
    end;
    if ChamadaAPI = 'boleto'  then begin
        Retorno:=true;

        if dados.toString = '' then begin
 //        if JA.Count = 0 then begin
           Showmessage('Boleto bancário não localizado!');
           Retorno:=false;
         exit;
       end;

       URL:='https://sindicatoamericana.com.br/boletos/';
       NomeArq:=URL+ FormatFloat('00000', Matricula)+'_'+Tipo+'_'+DataCobranca+'.pdf';
       asm
         fetch(NomeArq, { method: 'HEAD' })
         .then(function(response) {
         if (response.ok) {
          window.open(NomeArq, '_blank');
         } else {
           alert('Boleto bancário não localizado.');
         }
        })
        .catch(function(error) {
          alert('Erro ao verificar: ' + error);
        });
       end;


    end;

end;

procedure TFormPrincipal.EditCNPJEnter(Sender: TObject);
begin
     EditCNPJ.Text:='';
end;

procedure TFormPrincipal.EditCNPJKeyPress(Sender: TObject; var Key: Char);
begin
     if key = #13 then
        BotaoOKClick(self);

end;

procedure TFormPrincipal.OnHttpResponse(Sender: TObject; AResponse: string);
var
   i:integer;
   URL, NomeArq, Temp:string;

 js: TJSON;
 ja: TJSONArray;
 jo: TJSONObject;

begin

     JS := TJSON.Create;
     JA := TJSONArray(JS.Parse(AResponse));
    if ChamadaAPI = 'empresa' then begin
       if JA.Count = 0 then begin
          showmessage('CNPJ não encontrado!');
          LabelEmpresa.Caption:='';
          PainelContribuicao.Visible:=false;
          exit;
       end;
       WebComboBoxCategorias.Items.Clear;
       for i := 0 to JA.Count - 1 do begin
           JO := TJSONObject(JA.Items[i]);
           Matricula:=StrToIntDef(JO.GetJSONValue('MATRICULA'), 0);
           LabelEmpresa.caption:=JO.GetJSONValue('RAZAOSOCIAL');
           if JO.GetJSONValue('ODONTO') = 'T' then
              WebComboBoxCategorias.Items.Add('Convênio Odontológico');
           if JO.GetJSONValue('ASSISTENCIAL') = 'T' then
              WebComboBoxCategorias.Items.Add('Contribuição Assistencial');
           if JO.GetJSONValue('MENSALIDADE') = 'T' then
              WebComboBoxCategorias.Items.Add('Mensalidade Sindical');
           WebComboBoxCategorias.Items.Add('Negocial');
           PainelContribuicao.Visible:=true;
       end;
    end else if ChamadaAPI = 'boleto'  then begin
        Retorno:=true;
{
        if JA.Count = 0 then begin
           Showmessage('Boleto bancário não localizado!');
           Retorno:=false;
         exit;
       end;
}
       URL:='https://sindicatoamericana.com.br/boletos/';
       NomeArq:=URL+ FormatFloat('00000', Matricula)+'_'+Tipo+'_'+DataCobranca+'.pdf';
       asm
         fetch(NomeArq, { method: 'HEAD' })
         .then(function(response) {
         if (response.ok) {
          window.open(NomeArq, '_blank');
         } else {
           alert('Boleto bancário não localizado.');
         }
        })
        .catch(function(error) {
          alert('Erro ao verificar: ' + error);
        });
       end;


    end;


end;

procedure TFormPrincipal.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel2 := TPanel.Create(Self);
  WebPanel1 := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  LabelEmpresa := TLabel.Create(Self);
  BotaoOK := TBitBtn.Create(Self);
  EditCNPJ := TMaskEdit.Create(Self);
  PainelContribuicao := TPanel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebComboBoxCategorias := TComboBox.Create(Self);
  EditData := TDateTimePicker.Create(Self);
  WebButton1 := TButton.Create(Self);
  WebHttpRequest1 := THttpRequest.Create(Self);
  WebRESTClient1 := TRESTClient.Create(Self);
  ConnectionBanco := TClientConnection.Create(Self);

  WebPanel2.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  LabelEmpresa.BeforeLoadDFMValues;
  BotaoOK.BeforeLoadDFMValues;
  EditCNPJ.BeforeLoadDFMValues;
  PainelContribuicao.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebComboBoxCategorias.BeforeLoadDFMValues;
  EditData.BeforeLoadDFMValues;
  WebButton1.BeforeLoadDFMValues;
  WebHttpRequest1.BeforeLoadDFMValues;
  WebRESTClient1.BeforeLoadDFMValues;
  ConnectionBanco.BeforeLoadDFMValues;
  try
    Name := 'FormPrincipal';
    Width := 805;
    Height := 603;
    ElementClassName := 'full-center';
    ElementPosition := epRelative;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    WebPanel2.SetParentComponent(Self);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 151;
    WebPanel2.Top := 29;
    WebPanel2.Width := 534;
    WebPanel2.Height := 396;
    WebPanel2.ElementClassName := 'center-panel';
    WebPanel2.HeightPercent := 100.000000000000000000;
    WebPanel2.WidthPercent := 100.000000000000000000;
    WebPanel2.BorderColor := clSilver;
    WebPanel2.BorderStyle := bsSingle;
    WebPanel2.Caption := 'WebPanel2';
    WebPanel2.ChildOrder := 4;
    WebPanel2.ElementFont := efCSS;
    WebPanel2.ElementPosition := epRelative;
    WebPanel1.SetParentComponent(WebPanel2);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 534;
    WebPanel1.Height := 80;
    WebPanel1.HeightPercent := 100.000000000000000000;
    WebPanel1.WidthPercent := 100.000000000000000000;
    WebPanel1.Align := alClient;
    WebPanel1.BorderColor := clSilver;
    WebPanel1.BorderStyle := bsNone;
    WebLabel1.SetParentComponent(WebPanel1);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 16;
    WebLabel1.Top := 16;
    WebLabel1.Width := 184;
    WebLabel1.Height := 19;
    WebLabel1.Caption := 'Digite o CNPJ da empresa';
    WebLabel1.Font.Charset := DEFAULT_CHARSET;
    WebLabel1.Font.Color := clWindowText;
    WebLabel1.Font.Height := -16;
    WebLabel1.Font.Name := 'Tahoma';
    WebLabel1.Font.Style := [];
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.ParentFont := False;
    WebLabel1.WidthPercent := 100.000000000000000000;
    LabelEmpresa.SetParentComponent(WebPanel1);
    LabelEmpresa.Name := 'LabelEmpresa';
    LabelEmpresa.Left := 206;
    LabelEmpresa.Top := 47;
    LabelEmpresa.Width := 98;
    LabelEmpresa.Height := 19;
    LabelEmpresa.Caption := 'LabelEmpresa';
    LabelEmpresa.Font.Charset := DEFAULT_CHARSET;
    LabelEmpresa.Font.Color := clWindowText;
    LabelEmpresa.Font.Height := -16;
    LabelEmpresa.Font.Name := 'Tahoma';
    LabelEmpresa.Font.Style := [];
    LabelEmpresa.HeightPercent := 100.000000000000000000;
    LabelEmpresa.ParentFont := False;
    LabelEmpresa.WidthPercent := 100.000000000000000000;
    BotaoOK.SetParentComponent(WebPanel1);
    BotaoOK.Name := 'BotaoOK';
    BotaoOK.Left := 372;
    BotaoOK.Top := 15;
    BotaoOK.Width := 41;
    BotaoOK.Height := 25;
    BotaoOK.Color := clNone;
    BotaoOK.ElementClassName := 'mybtn';
    BotaoOK.ElementFont := efCSS;
    BotaoOK.Glyph.LoadFromFile('Principal.WebPanel1.BotaoOK.Glyph.png');
    BotaoOK.HeightPercent := 100.000000000000000000;
    BotaoOK.WidthPercent := 100.000000000000000000;
    SetEvent(BotaoOK, Self, 'OnClick', 'BotaoOKClick');
    EditCNPJ.SetParentComponent(WebPanel1);
    EditCNPJ.Name := 'EditCNPJ';
    EditCNPJ.Left := 206;
    EditCNPJ.Top := 14;
    EditCNPJ.Width := 160;
    EditCNPJ.Height := 27;
    EditCNPJ.Font.Charset := DEFAULT_CHARSET;
    EditCNPJ.Font.Color := clWindowText;
    EditCNPJ.Font.Height := -16;
    EditCNPJ.Font.Name := 'Tahoma';
    EditCNPJ.Font.Style := [];
    EditCNPJ.ParentFont := False;
    EditCNPJ.TabOrder := 0;
    EditCNPJ.Text := '';
    SetEvent(EditCNPJ, Self, 'OnEnter', 'EditCNPJEnter');
    SetEvent(EditCNPJ, Self, 'OnKeyPress', 'EditCNPJKeyPress');
    EditCNPJ.HeightPercent := 100.000000000000000000;
    EditCNPJ.WidthPercent := 100.000000000000000000;
    PainelContribuicao.SetParentComponent(WebPanel2);
    PainelContribuicao.Name := 'PainelContribuicao';
    PainelContribuicao.Left := 0;
    PainelContribuicao.Top := 80;
    PainelContribuicao.Width := 534;
    PainelContribuicao.Height := 316;
    PainelContribuicao.HeightPercent := 100.000000000000000000;
    PainelContribuicao.WidthPercent := 100.000000000000000000;
    PainelContribuicao.Align := alBottom;
    PainelContribuicao.BorderColor := clSilver;
    PainelContribuicao.BorderStyle := bsNone;
    PainelContribuicao.ChildOrder := 1;
    PainelContribuicao.Enabled := False;
    PainelContribuicao.Visible := False;
    WebLabel2.SetParentComponent(PainelContribuicao);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 74;
    WebLabel2.Top := 24;
    WebLabel2.Width := 126;
    WebLabel2.Height := 19;
    WebLabel2.Caption := 'Tipo Contribui'#231#227'o';
    WebLabel2.Font.Charset := DEFAULT_CHARSET;
    WebLabel2.Font.Color := clWindowText;
    WebLabel2.Font.Height := -16;
    WebLabel2.Font.Name := 'Tahoma';
    WebLabel2.Font.Style := [];
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.ParentFont := False;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebLabel3.SetParentComponent(PainelContribuicao);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 58;
    WebLabel3.Top := 51;
    WebLabel3.Width := 142;
    WebLabel3.Height := 19;
    WebLabel3.Caption := 'Data de Vencimento';
    WebLabel3.Font.Charset := DEFAULT_CHARSET;
    WebLabel3.Font.Color := clWindowText;
    WebLabel3.Font.Height := -16;
    WebLabel3.Font.Name := 'Tahoma';
    WebLabel3.Font.Style := [];
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.ParentFont := False;
    WebLabel3.WidthPercent := 100.000000000000000000;
    WebComboBoxCategorias.SetParentComponent(PainelContribuicao);
    WebComboBoxCategorias.Name := 'WebComboBoxCategorias';
    WebComboBoxCategorias.Left := 206;
    WebComboBoxCategorias.Top := 21;
    WebComboBoxCategorias.Width := 207;
    WebComboBoxCategorias.Height := 27;
    WebComboBoxCategorias.Font.Charset := DEFAULT_CHARSET;
    WebComboBoxCategorias.Font.Color := clWindowText;
    WebComboBoxCategorias.Font.Height := -16;
    WebComboBoxCategorias.Font.Name := 'Tahoma';
    WebComboBoxCategorias.Font.Style := [];
    WebComboBoxCategorias.HeightPercent := 100.000000000000000000;
    WebComboBoxCategorias.ParentFont := False;
    WebComboBoxCategorias.Text := 'Conv'#234'nio Odontol'#243'gico';
    WebComboBoxCategorias.WidthPercent := 100.000000000000000000;
    WebComboBoxCategorias.ItemIndex := 0;
    WebComboBoxCategorias.Items.BeginUpdate;
    try
      WebComboBoxCategorias.Items.Clear;
      WebComboBoxCategorias.Items.Add('Conv'#234'nio Odontol'#243'gico');
      WebComboBoxCategorias.Items.Add('Contribui'#231#227'o Assistencial');
      WebComboBoxCategorias.Items.Add('Mensalidade Sindical');
      WebComboBoxCategorias.Items.Add('Negocial');
    finally
      WebComboBoxCategorias.Items.EndUpdate;
    end;
    EditData.SetParentComponent(PainelContribuicao);
    EditData.Name := 'EditData';
    EditData.Left := 206;
    EditData.Top := 50;
    EditData.Width := 139;
    EditData.Height := 22;
    EditData.HeightPercent := 100.000000000000000000;
    EditData.WidthPercent := 100.000000000000000000;
    EditData.BorderStyle := bsSingle;
    EditData.ChildOrder := 4;
    EditData.Color := clWhite;
    EditData.Date := 45799.430303506950000000;
    EditData.Font.Charset := DEFAULT_CHARSET;
    EditData.Font.Color := clWindowText;
    EditData.Font.Height := -16;
    EditData.Font.Name := 'Tahoma';
    EditData.Font.Style := [];
    EditData.ParentFont := False;
    EditData.Role := '';
    EditData.ShowSeconds := False;
    EditData.Text := '';
    WebButton1.SetParentComponent(PainelContribuicao);
    WebButton1.Name := 'WebButton1';
    WebButton1.Left := 58;
    WebButton1.Top := 78;
    WebButton1.Width := 359;
    WebButton1.Height := 54;
    WebButton1.Caption := 'Imprimir Cobran'#231'a';
    WebButton1.ChildOrder := 6;
    WebButton1.ElementClassName := 'botao-verde';
    WebButton1.HeightPercent := 100.000000000000000000;
    WebButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton1, Self, 'OnClick', 'WebButton1Click');
    WebHttpRequest1.SetParentComponent(Self);
    WebHttpRequest1.Name := 'WebHttpRequest1';
    WebHttpRequest1.Headers.BeginUpdate;
    try
      WebHttpRequest1.Headers.Clear;
      WebHttpRequest1.Headers.Add('Cache-Control=no-cache, no-store, must-revalidate');
    finally
      WebHttpRequest1.Headers.EndUpdate;
    end;
    WebHttpRequest1.Left := 448;
    WebHttpRequest1.Top := 208;
    WebRESTClient1.SetParentComponent(Self);
    WebRESTClient1.Name := 'WebRESTClient1';
    WebRESTClient1.Left := 448;
    WebRESTClient1.Top := 272;
    ConnectionBanco.SetParentComponent(Self);
    ConnectionBanco.Name := 'ConnectionBanco';
    ConnectionBanco.Active := False;
    SetEvent(ConnectionBanco, Self, 'OnDataReceived', 'ConnectionBancoDataReceived');
    ConnectionBanco.Left := 88;
    ConnectionBanco.Top := 248;
  finally
    WebPanel2.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    LabelEmpresa.AfterLoadDFMValues;
    BotaoOK.AfterLoadDFMValues;
    EditCNPJ.AfterLoadDFMValues;
    PainelContribuicao.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebComboBoxCategorias.AfterLoadDFMValues;
    EditData.AfterLoadDFMValues;
    WebButton1.AfterLoadDFMValues;
    WebHttpRequest1.AfterLoadDFMValues;
    WebRESTClient1.AfterLoadDFMValues;
    ConnectionBanco.AfterLoadDFMValues;
  end;
end;

end.
